



























































































































































import { compass } from '@resclick/compass';
import { ICurrency, IUser, PROPERTY_TYPES } from '@resclick/data-access';
import { date } from 'quasar';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component
export default class Cart extends Vue {
  @State('cart') cart!: any;
  @Action('cart/addToCart') addToCart!: (product: any) => void;
  @Action('cart/changeCurrency') changeCurrency!: (currency: string) => void;
  @Action('cart/removeFromCart') removeFromCart!: (index: number) => void;
  @Action('cart/fetchCart') fetchCart!: () => void;
  @State('user') user!: IUser;
  @Prop() orderId?: string;

  loading = false;
  currencies: ICurrency[] = [];
  order: any = {};

  async addCancellationInsurance() {
    const price = this.products.reduce(
      (total: { value: number; currency: string }, product: any) => {
        if (product.productCategory === 'PROPERTY') {
          total.value = product.price.value;
          total.currency = product.price.currency;
        }

        return total;
      },
      { value: 0, currency: '' },
    );

    const market = this.products.find((product: any) => product.productCategory === 'PROPERTY').market;

    const { data } = await compass.do('prices', 'getCancellationInsurancePrice', {
      data: {
        price,
        market,
        bookingDate: new Date(),
      },
    });

    this.addToCart(data);
  }

  get propertyTypes() {
    return PROPERTY_TYPES;
  }

  get isLoading() {
    return this.orderId ? this.cart.isLoading : this.loading;
  }

  get products() {
    const { products = [] } = this.order.id ? this.order : this.cart;
    return products.map((product: any) => {
      const result = JSON.parse(JSON.stringify(product));
      if (this.propertyTypes.includes(result.type)) {
        result.roomName = product.room?.displayName;
        result.propertyName = product.room?.property?.name;
        result.stayNights = date.getDateDiff(product.checkOutDate, product.checkInDate, 'days');
        result.checkInDate = this.$formatDate(product.checkInDate);
        result.checkOutDate = this.$formatDate(product.checkOutDate);
      }

      return result;
    });
  }

  get total() {
    return this.orderId ? this.order?.total : this.cart?.total;
  }

  getOrder() {
    if (this.orderId) {
      this.loading = true;
      compass
        .do('orders', 'findOne', {
          params: { orderId: this.orderId },
          query: {
            currency: this.user?.preferences?.currency,
          },
          populate: [
            {
              path: 'products.room',
              select: ['displayName'],
              populate: [{ path: 'property', select: 'name' }],
            },
            {
              path: 'products.ratePlan',
              select: ['name'],
            },
            {
              path: 'products.cancellationPolicy',
              select: ['name'],
            },
            {
              path: 'products.concept',
              select: ['name'],
            },
          ],
        })
        .then((res) => (this.order = res.data))
        .finally(() => (this.loading = false));
    }
  }

  @Watch('user.preferences.currency')
  onCurrencyChange() {
    this.orderId ? this.getOrder() : this.fetchCart();
  }

  created() {
    this.onCurrencyChange();
  }
}
